module.exports = __webpack_public_path__ + "static/media/Sales2.631c7496.png";